import { useTranslations } from '@vocab/react';
import { Heading, Stack, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';
import { EmptyIllustration } from './svg/EmptyIllustration';

export const ShareableProfileEmptyPage = () => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="medium" align="center">
      <EmptyIllustration />
      <Stack space="small" align="center">
        <Heading
          level="3"
          component="h1"
          align="center"
          data={{ automation: 'empty-page-title' }}
        >
          {t('No information yet')}
        </Heading>
        <Text tone="secondary">
          {t("This shared profile hasn't been set up")}
        </Text>
      </Stack>
    </Stack>
  );
};
